var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tenant.homePageType === '1')?_c('new-home'):_vm._e(),(_vm.tenant.homePageType === '2')?_c('yunyuan-home'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }